import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {LibConfig, LibConfigService} from '../lib.config';
import {BaseObservableService} from './base-obeservable-service';
import {WifiPrinter} from '../_models/wifi-printer';
import {OrganizationService} from './organization.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {Constants} from '../_constants/constants';

@Injectable({
    providedIn: 'root'
})
export class WifiPrinterService extends BaseObservableService<WifiPrinter> {
    destination = 'wifi-printers';

    public wifiPrinters: Observable<WifiPrinter[]>;
    private wifiPrintersSubject: BehaviorSubject<WifiPrinter[]>;

    constructor(
        http: HttpClient,
        @Inject(LibConfigService) config: LibConfig,
        private organizationService: OrganizationService
    ) {
        super(http, config);

        this.wifiPrintersSubject = new BehaviorSubject<WifiPrinter[]>(null);
        this.wifiPrinters = this.wifiPrintersSubject.asObservable();
    }

    findByOrganizationId(organizationId: number) {
        const headers = new HttpHeaders().set(Constants.SILENT, 'true');
        return this.http.get(`${this.baseUrl()}/organization/${organizationId}`, {headers});
    }

    setCurrent(val) {
        const o = this.organizationService.currentValue;
        if (!!val) {
            localStorage.setItem(`WIFI_PRINTER_${o.id}`, JSON.stringify(val.id));
        } else {
            localStorage.removeItem(`WIFI_PRINTER_${o.id}`);
        }
        super.setCurrent(val);
    }

    setPrinters(printers: WifiPrinter[]) {
        const current = this.currentValue;
        const organization = this.organizationService.currentValue;
        const stored = !!organization ? localStorage.getItem(`WIFI_PRINTER_${organization.id}`) : null;
        if (!!current || !!stored) {
            const storedId = !!stored ? Number(stored) : !!current ? current.id : null;
            if (!!storedId && !!printers) {
                const w = printers.find(p => p.id === storedId);
                if (!!w) {
                    this.setCurrent(new WifiPrinter(w));
                }
            }
        }
        this.wifiPrintersSubject.next(printers);
    }

    get printers(): WifiPrinter[] {
        return this.wifiPrintersSubject.getValue();
    }
}
